import React from 'react'


const About = () => {
    return (
        <div className=' d-flex justify-content-center align-items-center' style={{ backgroundColor:'#000',  height:'100vh'}} >
            <h1 className='text-light' style={{ fontWeight:'900' , fontSize:'80px'}}> SOON</h1>
        </div>
    )
}

export default About
